<template>
<div style="width:100%; padding-top: 34px">
  <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
      <screenButton class="screenButton"></screenButton>
    </div>
  </div>

  <subjectTemplateTreeTable ref="subjectTemplateTreeTable" :data="dataList" :subjectTypeId="subjectTypeId"></subjectTemplateTreeTable>
<!--  <div v-else>-->
<!--    <b-table class="bgc-dark" small head-variant="dark" responsive bordered-->
<!--             :items="dataList" :fields="fields">-->
<!--      <template v-slot:head()="scope">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center'}">-->
<!--          {{ scope.label }}-->
<!--        </div>-->
<!--      </template>-->

<!--      <template v-slot:table-colgroup="scope">-->
<!--        <col-->
<!--            v-for="field in scope.fields"-->
<!--            :key="field.key"-->
<!--            :style="{ width: '100px' }"-->
<!--        >-->
<!--      </template>-->
<!--    </b-table>-->
<!--  </div>-->
</div>
</template>

<script>
import subjectTemplateTreeTable from "../../../../components/subjectTemplateTreeTable/subjectTemplateTreeTable.vue";
export default {
  name: "ItsBaseSubjectTemplateDetail",
  data(){
    return {
      dataList: [],
      subjectTypeId: '',
      id: '',
    }
  },
  created() {
    // this.costBudgetPreparationAnnualService = new CostBudgetPreparationAnnualService()
    this.dataList = this.arrayToTree( JSON.parse(this.$route.query.data))
  },
  activated() {
  },
  components: {
    subjectTemplateTreeTable
  },
  methods: {
    init(){

    },
    arrayToTree(data) {
      const map = new Map();
      const tree = [];

      // 创建每个节点的映射（根据 id 存储每个节点）
      data.forEach(item => {
        map.set(item.id, { ...item, children: [] });
      });

      // 生成树状结构
      data.forEach(item => {
        if (item.subjectParentId === '0') {
          tree.push(map.get(item.id));
        } else {
          const parent = map.get(item.subjectParentId);
          if (parent) {
            parent.children.push(map.get(item.id));
          }
        }
      });
      return tree;
    },
    goBack(){
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>